module.exports = __webpack_public_path__ + "static/media/login_full_bg1.6dca9ca6.jpg";